export const fetchJokes = () => {
    return (dispatch) => {
        fetch('https://official-joke-api.appspot.com/random_ten')
        .then((res) => {
            return res.json()
        })
        .then((data) => {
            dispatch({type: 'SET_JOKES', payload: data})
        })
        .catch(console.log)
    }
}

export const ADD_FAVORITE = (jokes) => {
    return {
        type: 'ADD_FAVORITE',
        payload: {
            jokes
        }
    }
} 